<script setup>
import JobForm from '@/components/polyhen/job/JobForm.vue'

definePage({
    meta: {
        action: 'view',
        subject: 'orders',
    },
})
</script>

<template>
    <JobForm mode="create" />
</template>
